module.exports = __webpack_public_path__ + "static/media/image_29.0bf923ef.png";